module.exports = __webpack_public_path__ + "static/logo_dark-f9cc8f12cd8418256ab7b83ce92d92dd.png";